module.exports = __webpack_public_path__ + "img/icon-campaign-add.218b4751.svg";